import { createFileRoute } from '@tanstack/react-router'

import { PageLayout } from '@/components/layout'

import { DeviceForm } from '@/features/outlet/components/device-form'

export const Route = createFileRoute('/_app/outlet/device/create')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  return (
    <PageLayout>
      <DeviceForm mode='create' onBack={() => navigate({ to: '/outlet/device', replace: true })} />
    </PageLayout>
  )
}
